const SITE_URL = "https://www.reignitespirit.com";

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  url: SITE_URL,
  name: "ReigniteSpirit",
  alternateName: "Reignite Spirit",

  description:
    "Career intelligence tools, career transition reports, financial runway planning and practical career guidance.",

  publisher: {
    "@id": `${SITE_URL}/#organization`,
  },

  inLanguage: "en",
};